import { useQuery } from '@tanstack/react-query';
import { metadataApi } from '../services/metadataApi';

export const usePaymentTerms = () => {
  return useQuery({
    queryKey: ['paymentTerms'],
    queryFn: metadataApi.getPaymentTerms,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};

export const useCounties = () => {
  return useQuery({
    queryKey: ['counties'],
    queryFn: metadataApi.getCounties,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};

export const useInvoiceStatuses = () => {
  return useQuery({
    queryKey: ['metadata', 'invoice-statuses'],
    queryFn: metadataApi.getInvoiceStatuses,
    staleTime: 1000 * 60 * 60,
  });
};

export const useVatRates = () => {
  return useQuery({
    queryKey: ['metadata', 'vat-rates'],
    queryFn: metadataApi.getVatRates,
    staleTime: 1000 * 60 * 60,
  });
};

export const useInquiryStatuses = () => {
  return useQuery({
    queryKey: ['metadata', 'inquiry-statuses'],
    queryFn: metadataApi.getInquiryStatuses,
    staleTime: 1000 * 60 * 60,
  });
};

export const useInquiryPriorities = () => {
  return useQuery({
    queryKey: ['metadata', 'inquiry-priorities'],
    queryFn: metadataApi.getInquiryPriorities,
    staleTime: 1000 * 60 * 60,
  });
};

export const useCallDirections = () => {
  return useQuery({
    queryKey: ['metadata', 'call-directions'],
    queryFn: metadataApi.getCallDirections,
    staleTime: 1000 * 60 * 60,
  });
};

export const useCallSources = () => {
  return useQuery({
    queryKey: ['metadata', 'call-sources'],
    queryFn: metadataApi.getCallSources,
    staleTime: 1000 * 60 * 60,
  });
};

export const useOrderStatuses = () => {
  return useQuery({
    queryKey: ['metadata', 'order-statuses'],
    queryFn: metadataApi.getOrderStatuses,
    staleTime: 1000 * 60 * 60,
  });
};